import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col, 
  Alert,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"
import Select from "react-select"
// import { Doughnut } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut, PolarArea } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

// if(ChartJS.Legend && ChartJS.Legend.prototype) {
//   ChartJS.Legend.prototype.afterFit = function() {
//     this.height = this.height + 250;
//   };
// }

// import { PolarArea } from 'react-chartjs-2';

// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// ChartJS.register(ArcElement, Tooltip, Legend);


const OneDashboard = props => {

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'Today', value: 'today' });
  const [startDate, setStartDate] = React.useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));
  
  const [data, setData] = React.useState([]);

  const [property, setProperty] = React.useState(null);
  const [block, setBlock] = React.useState(null);

  const [txtProperty, setTxtProperty] = React.useState('Select Property');
  const [txtBlock, setTxtBlock] = React.useState('Select Block');

  const [properties, setProperties] = React.useState([]);
  const [blocks, setBlocks] = React.useState([]);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(true);

  const [alerts, setAlerts] = React.useState('-');
  const [logs, setLogs] = React.useState('-');

  const [dailyStats, setDailyStats] = React.useState({
    scheduled : 0,
    completed : 0,
    pending : 0,
    missed : 0,
    delayd : 0,
    cancelled : 0,
  });

  const [ppmStats, setPpmStats] = React.useState({
    scheduled : 0,
    completed : 0,
    pending : 0,
    missed : 0,
    delayd : 0,
    cancelled : 0,
  });



  const dateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ];

  

  const init = async () => {

    let initData = {
      // property_id: props.filterProperty.id,
      // block_id: props.filterBlock.id,
    };

    await setLoading(true);
    post(url.INIT_ONEDASHBOARD, initData)
      .then(async(response) => {
        console.log('RESP', response);
        if (response.status == 200) {
        await setProperties(response.data);
        let tempProp = response.data.find(d => d.value == 16);
        await setProperty(tempProp);
        let tempBlock = tempProp.blocks.find(b => b.value == 65);
        await setBlock(tempBlock);
        // setTimeout(() => {
          fetchData(startDate, endDate, tempProp.label, tempBlock.label);
        // }, 500);
        // setProperty(properties[0]);
        // setBlock(properties[0].blocks[0]);
        }
        else if (response.status == 400) {
          cogoToast.error('Could not fetch data');
          setLoading(false);
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not fetch data');
          setLoading(false);
        }
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };





  


  const fetchData = (start_date, end_date, property_id, block_id) => {
    console.log('start_date, end_date, property_id, block_id', 
      start_date, end_date, property_id, block_id);
      setLoading(true);
      post(url.GET_ONEDASHBOARD, 
        {
          start_date: start_date,
          end_date: end_date,
          property_id: property_id,
          block_id: block_id,
        })
        .then(response => {
          console.log('RESP', response);

          if (response.status == 200) {
            setDailyStats(response.data.dailytasks);
            setPpmStats(response.data.ppmtasks);
            setAlerts(response.data.alerts);
            setLogs(response.data.logs);

            setTxtProperty(property_id);
            setTxtBlock(block_id);

            setLoading(false);
          }
          else {
            console.log('Access denied for '+block_id);
            setLoading(false);
          }




      // if (response.status == 200) {
      //   // setEvents(response.data.events);
      //   // setServiceTypes(response.data.servicetypes);
      //   // setGroups(response.data.groups);
      //   // setLoading(false);
      //   // setCurrMonth(month);
      //   // setCurrYear(year);
      // }
      // else {
      //   setData(null);
      //   setLoading(false);
      // }
    })
      .catch(error => {
        console.log('err:', error);
        setLoading(false);
      });
  };










  React.useEffect(()=>{
    init();
  }, []);

  // console.log(ppmStats);


  const chartData = {
    labels: ['Completed', 'Pending', 'Missed', 'Delayed', 'Cancelled'],
    datasets: [
      {
        label: '# of Tasks',
        data: [
          // dailyStats.scheduled,
          dailyStats.completed,
          dailyStats.pending,
          dailyStats.missed,
          dailyStats.delayd,
          dailyStats.cancelled,
        ],
        backgroundColor: [
          // '#3e85f58f',
          '#50cf308f',
          '#e7a11f8f',
          '#e750118f',
          '#23bda28f',
          '#a15fbd8f',
        ],
        borderColor: [
          // '#3e85f533',
          '#50cf3033',
          '#e7a11f33',
          '#e7501133',
          '#23bda233',
          '#a15fbd33',
        ],
        borderWidth: 1,
      },
    ],
  };


  const ppmChartData = {
    labels: ['Completed', 'Pending', 'Missed', 'Delayed', 'Cancelled'],
    datasets: [
      {
        label: '# of Tasks',
        data: [
          // ppmStats.scheduled,
          ppmStats.completed,
          ppmStats.pending,
          ppmStats.missed,
          ppmStats.delayd,
          ppmStats.cancelled,
        ],
        backgroundColor: [
          // '#3e85f58f',
          '#50cf308f',
          '#e7a11f8f',
          '#e750118f',
          '#23bda28f',
          '#a15fbd8f',
        ],
        borderColor: [
          // '#3e85f533',
          '#50cf3033',
          '#e7a11f33',
          '#e7501133',
          '#23bda233',
          '#a15fbd33',
        ],
        borderWidth: 1,
      },
    ],
  };


  // console.log(dailyStats, ppmStats, chartData.datasets[0].data, ppmChartData.datasets[0].data);


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>One Dashboard</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="mb-0" style={{fontSize: 16,}}>DIGITAL LOGBOOK DASHBOARD</h4>
            <p className="mb-0">Digital Logbook / Digital Logbook Dashboard</p>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <div className="mt-5 d-flex flex-row justify-content-between align-items-center w100">
            <div className="d-flex flex-row justify-content-start align-items-center">
              <div className="me-3" style={{minWidth: '12vw'}}>
                <label className="label form-label">Period</label>
                <Select
                    classNamePrefix="select2-selection"
                    placeholder="Select one..."
                    title="Set to..."
                    options={dateOptions}
                    value={selectedDateOption}
                    isDisabled={loading}
                    onChange={async e => { 
                      if(e.value == 'today') {
                        await setStartDate(moment().format('YYYY-MM-DD'));
                        await setEndDate(moment().format('YYYY-MM-DD'));
                        fetchData(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), property?.label, block?.label); 
                      }
                      else if(e.value == 'yesterday') {
                        await setStartDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                        await setEndDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                        fetchData(moment().subtract(1, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD'), property?.label, block?.label); 
                      }
                      else if(e.value == 'weekly') {
                        await setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                        await setEndDate(moment().format('YYYY-MM-DD'));
                        fetchData(moment().subtract(1, 'week').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), property?.label, block?.label); 
                      }
                      else if(e.value == 'monthly') {
                        await setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                        await setEndDate(moment().format('YYYY-MM-DD'));
                        fetchData(moment().subtract(1, 'month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), property?.label, block?.label); 
                      }
                        await setSelectedDateOption(e); 

                    }}
                    />
              </div>
              <div className="me-3" style={{minWidth: '12vw'}}>
                <label className="label form-label">From</label>
                <input type="text" className="form-control" id="dateFrom"
                  type="date"
                  disabled={loading}
                  value={startDate} onChange={e => { 
                    setStartDate(e.target.value); 
                    setSelectedDateOption(null);
                    fetchData(e.target.value, endDate, property?.label, block?.label); 
                  }}
                />
              </div>
              <div className="me-3" style={{minWidth: '12vw'}}>
                  <label className="label form-label">To</label>
                  <input type="text" className="form-control" id="dateFrom"
                    disabled={loading}
                    type="date"
                    value={endDate} onChange={e => { 
                      setEndDate(e.target.value); 
                      setSelectedDateOption(null);
                      fetchData(startDate, e.target.value, property?.label, block?.label); 
                    }}
                  />
              </div>
            </div>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <div className="me-3" style={{minWidth: '12vw'}}>
                <label className="label form-label">Property</label>
                <Select
                    classNamePrefix="select2-selection"
                    placeholder="Select one..."
                    isDisabled={loading}
                    title="Set to..."
                    options={properties}
                    value={property}
                    onChange={e => { 
                      setProperty(e); 
                    }}
                    />
              </div>
              <div className="me-3" style={{minWidth: '12vw'}}>
                <label className="label form-label">Block</label>
                <Select
                    classNamePrefix="select2-selection"
                    placeholder="Select one..."
                    title="Set to..."
                    options={property ? property.blocks : []}
                    isDisabled={loading}
                    value={block}
                    onChange={e => { 
                      setBlock(e); 
                      fetchData(startDate, endDate, property?.label, e.label); 
                    }}
                    />
              </div>
            </div>
          </div>

          <div className="mt-4 d-flex flex-row justify-content-between align-items-center w100 position-relative">
            <div className="flex-1 bg-white shadow shadow-xs py-3 px-5 me-5" style={{}}>
              <div className="fs-4 mb-3 fw-semibold">
                <i className="bx bx-list-ul align-middle me-2" style={{color: '#000a', fontSize: 16,}}></i>
                  {" "}Daily tasks
              </div>
              <div className="py-3 rounded" style={{backgroundColor: '#f8f8fc', position: 'relative'}}>
                <div className="" style={{ width: '80%', marginLeft: '5%'}}>
                  <Doughnut 
                    data={chartData} 
                    options={{
                      plugins: {
                        legend: {
                          display: false,
                        }
                      }
                    }}
                    />
                  </div>
                  { dailyStats.scheduled < 1 &&
                    <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroudColor: '#fffa', 
                      display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#0007'}}>
                      No data
                    </div>
                  }
                </div>
                <div className="mt-4 d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#fff', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2 fw-bold">
                    Scheduled
                  </div>
                  <div className="flex-1 py-2 text-right fw-bold">
                    {dailyStats.scheduled}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#50cf30', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Completed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {dailyStats.completed} / {dailyStats.scheduled < 1 ? '-' : ((dailyStats.completed / dailyStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#e7a11f', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Pending
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {dailyStats.pending} / {dailyStats.scheduled < 1 ? '-' : ((dailyStats.pending / dailyStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#e75011', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Missed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {dailyStats.missed} / {dailyStats.scheduled < 1 ? '-' : ((dailyStats.missed / dailyStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#23bda2', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Delayed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {dailyStats.delayd} / {dailyStats.scheduled < 1 ? '-' : ((dailyStats.delayd / dailyStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center mb-2">
                  <div style={{backgroundColor: '#a15fbd', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Cancelled
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {dailyStats.cancelled} / {dailyStats.scheduled < 1 ? '-' : ((dailyStats.cancelled / dailyStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
            </div>
            <div className="flex-1 bg-white shadow shadow-xs py-3 px-5" style={{}}>
              <div className="mb-3 d-flex flex-row justify-content-between align-items-center">
                <div className="fs-4 fw-semibold">
                  <i className="bx bx-list-ul align-middle me-2" style={{color: '#000a', fontSize: 16,}}></i>
                    {" "}PPM tasks
                </div>
                <div className="fs-5 fw-semibold" style={{color: '#0024'}}>
                  {moment(startDate).format('MMM YYYY')}
                </div>
              </div>
              <div className="py-3 rounded" style={{backgroundColor: '#f8f8fc', position: 'relative'}}>
                <div className="" style={{ width: '80%', marginLeft: '5%'}}>
                  <Doughnut 
                    data={ppmChartData} 
                    options={{
                      plugins: {
                        legend: {
                          display: false,
                        }
                      }
                    }}
                    />
                  </div>
                  { ppmStats.scheduled < 1 &&
                    <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroudColor: '#fffa', 
                      display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#0007'}}>
                      No data
                    </div>
                  }
              </div>
                <div className="mt-4 d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#fff', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2 fw-bold">
                    Scheduled
                  </div>
                  <div className="flex-1 py-2 text-right fw-bold">
                    {ppmStats.scheduled}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#50cf30', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Completed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {ppmStats.completed} / {ppmStats.scheduled < 1 ? '-' : ((ppmStats.completed / ppmStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#e7a11f', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Pending
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {ppmStats.pending} / {ppmStats.scheduled < 1 ? '-' : ((ppmStats.pending / ppmStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#e75011', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Missed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {ppmStats.missed} / {ppmStats.scheduled < 1 ? '-' : ((ppmStats.missed / ppmStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center">
                  <div style={{backgroundColor: '#23bda2', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Delayed
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {ppmStats.delayd} / {ppmStats.scheduled < 1 ? '-' : ((ppmStats.delayd / ppmStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
                <div className="d-flex flex-row space-between align-items-center mb-2">
                  <div style={{backgroundColor: '#a15fbd', width: 10, height: 20, marginRight: 15, }} />
                  <div className="flex-1 py-2">
                    Cancelled
                  </div>
                  <div className="flex-1 py-2 text-right fw-medium">
                    {ppmStats.cancelled} / {ppmStats.scheduled < 1 ? '-' : ((ppmStats.cancelled / ppmStats.scheduled)*100).toFixed(0)+'%'}
                  </div>
                </div>
            </div>
            <div className="flex-1 py-2 px-5" 
              // style={{borderColor: '#0005', borderWidth: 0.5, borderStyle: 'solid' }}
              >
              <h3 className="fs-3">{txtProperty}</h3>
              <h4 className="mb-3 fs-4">{txtBlock}</h4>
              <p className="fs-5 mb-4 fw-light" style={{color: '#0008'}}>
                <i className="bx bx-calendar font-size-16 align-middle me-2" style={{color: '#0006'}}></i>
                  {" "}{moment(startDate).format('DD MMM YYYY')} - {moment(endDate).format('DD MMM YYYY')}
              </p>
              <p className="fs-5 mb-3">
                <i className="bx bx-alarm font-size-16 align-middle me-2" style={{color: '#0006'}}></i>
                  {" "}Alerts Generated: <span className="fw-bold">{alerts}</span></p>
              <p className="fs-5 mb-5">
                <i className="bx bx-error font-size-16 align-middle me-2" style={{color: '#0006'}}></i>
                  {" "}Asset Status Updates: <span className="fw-bold">{logs}</span></p>
              <div>
                <a
                  color="primary"
                  className="btn btn-primary "
                  href="http://logbook.six30labs.com/ssologin/BBBC7128934CF3A7500F88C4C528F06DF0E0F3A77C7ABE5AA6277506ABA98E3E/admin"
                  target="_blank"
                >
                  <i className="bx bx-right-arrow font-size-16 align-middle me-2"></i>
                  {" "}Launch
                </a>
              </div>
              <div>
                <Button
                  color="primary"
                  className="mt-3 btn btn-secondary "
                  onClick={()=>{ 
                    // 
                   }}
                  disabled={loading}
                >
                  <i className="bx bx-export font-size-16 align-middle me-2"></i>
                  {" "}Export
                </Button>
              </div>
            </div>
          
            {loading &&
              <div className="" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99, 
                backgroundColor: '#fffd', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div className="text-center py-5 fs-6">
                  <i className="bx bx-loader-alt bx-spin text-info fs-4"></i>
                  <span className="ps-2">Loading</span>
                </div>
              </div>
              }
          
          </div>




        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(OneDashboard)